/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Box, Button, Drawer, LinearProgress, Tooltip, Typography } from "@mui/material";
import { ShoppingCart, Close, ErrorOutlineOutlined } from "@mui/icons-material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { useObservable } from "src/framework/store/storeUtil";
import { CarrinhoStore, CarrinhoStoreClass } from "./store";
import "./styles.scss";
import { ItemMini } from "./ItemMini/inde";
import { Item } from "./Item";
import { Formater, LocalStorage, TypeRecords } from "src/framework/commons";
import jwtDecode from "jwt-decode";
import jwt from "jwt-simple";
import { confirmationDialog } from "src/framework/components/commons/dialogs/Confirmation/store";
import { notifierStore } from "src/framework/components/commons/dialogs/Notifier/store";
import theme from "src/theme/light";
import { avulsos$, estadoId$, getAvulsos, padronizaVenda, tipoVenda$ } from "src/store/global.store";
import { TCarrinhoAvulso } from "./types";
import { ItemAvulso } from "./ItemAvulso";
import { PROJETOS_AVULSO_VALOR_MINIMO_ID } from "src/constants";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { permissoes$ } from "src/framework/store";
import { CABO_ID } from "src/pages/Home/constants";
import { AppError } from "src/framework/exceptions/AppError";

export interface ICarrinho {
    store: CarrinhoStoreClass;
    anchor?: "left" | "right" | "top" | "bottom";
}

const Carrinho: FC<ICarrinho> = ({ store, anchor = "right" }) => {
    const open = useObservable(store.open)
    const carrinho = useObservable(store.carrinho);
    const estadoId = useObservable(estadoId$) || "";
    const avulsos = useObservable(avulsos$) || [];
    const tipoVenda = useObservable(tipoVenda$) || LocalStorage.get("solar.tipo_venda_selecionada");
    const parametros = LocalStorage.get("solar.parametros", true) || [];
    const [updated, setUpdated] = useState<boolean>(false);

    const isAdmin = useMemo(() => {
        return PermissionUtil.isAdministrador(permissoes$.value)
    }, []);

    const valorTotal = () => {
        let total = 0;
        if (carrinho?.venda === "avulso") {
            carrinho?.avulsos?.forEach((item: TCarrinhoAvulso) => {
                total += item.quantidade * CarrinhoStoreClass.valorAvulso(item, estadoId);
            });
        } else {
            carrinho?.itens?.forEach((item: any) => {
                total += item.quantidade * CarrinhoStoreClass.valorTotal(item);
            });

        }
        return total;
    }
    const handleRedirectProjetos = (url_projetos: string) => {
        const _tokenApi = LocalStorage.get("solar.token");
        if (_tokenApi) {
            const decoded: any = jwtDecode(_tokenApi);
            const _tokenProjetos = {
                cnpj_cpf: decoded.user.cnpjCpf,
                token: decoded.token,
                refresh_token: decoded.refreshToken,
                access_token: decoded.token,
                type: decoded.type,
                customContaUnica: decoded.customContaUnica
            }
            if (!process.env.REACT_APP_TOKEN_KEY) {
                throw new Error("REACT_APP_TOKEN_KEY não definida");
            }
            const tProjetos = jwt.encode(_tokenProjetos, process.env.REACT_APP_TOKEN_KEY);
            const tVenda = padronizaVenda(tipoVenda);

            const _url = `token=${tProjetos}&venda=${tVenda}`;
            window.location.href = `${url_projetos}&${_url}`;
        }
    }

    const handleFinalizarCarrinho = () => {
        confirmationDialog.setup({
            title: "Atenção!",
            content: <>
                <strong>Finalizar pedido</strong>
                <br/>
                <br/>
                Ao finalizar a compra na loja não será mais possível editar as quantidades e itens adicionados no carrinho.
            </>,
            onClose: () => {
                confirmationDialog.close();
            },
            noText: "Cancelar",
            yesText: "Confirmar",
            noVariant: isAvulso ? "outlined" : "text",
            onConfirmation: async () => {
                try {
                    const redirect = await CarrinhoStore.finalizar();
                    confirmationDialog.close();
                    store.toggleOpen();
                    handleRedirectProjetos(redirect?.projetos_url + "");
                } catch (error) {

                    if (error instanceof AppError) {
                        error.openNotifier();
                        return;
                    }

                    notifierStore.setNotifier({
                        title: "Aviso!",
                        content: "Erro ao finalizar carrinho",
                        onClose: () => window.location.reload(),
                        onFinishTimeout: () => window.location.reload(),
                    })
                    notifierStore.open();
                }
            }
        })
        confirmationDialog.open();
    }

    const handleEsc = useCallback((e: any) => {
        if (e.keyCode === 27) {
            store.setOpen(false);
        }
    }, [store])


    useEffect(() => {
        if (open) {
            window.addEventListener("keydown", handleEsc, true);
        } else {
            window.removeEventListener("keydown", handleEsc, true);
        }

    }, [handleEsc, open]);

    useEffect(() => {
        if (carrinho?.avulsos?.length && carrinho?.venda === 'avulso') {
            getAvulsos(estadoId);
        }
    }, [carrinho, estadoId, open]);

    const checkError = useCallback((categoriaId: number, qtd: number): boolean => {
        if (categoriaId !== CABO_ID) {
            return false;
        }
        if (qtd === 0) {
            return false;
        }
        if (qtd % 25 === 0) {
            return false;
        }
        return true
    }, []);

    const itensCarrinho = useMemo(() => {
        const isAvulso = carrinho?.venda === 'avulso';
        const lista = (isAvulso ? carrinho?.avulsos : carrinho?.itens) || [];
        if (!isAvulso) return lista;

        return lista
            .map((item: TCarrinhoAvulso, index: number) => ({
                ...item,
                _originalIndex: index,
            })).sort((a: TCarrinhoAvulso, b: TCarrinhoAvulso) => (a?.id || 0) - (b?.id || 0));

    }, [carrinho?.venda, carrinho?.avulsos, carrinho?.itens]);

    const renderKit = useMemo(() => {
        return (<>
            {itensCarrinho?.map((item: any, index: number) => {
                return <Item
                    key={`item-${index}`}
                    index={index}
                    item={item}
                    onChange={(_index, _quantidade) => {
                        const carrinho = { ...store.getCarrinho() };
                        if (carrinho?.itens?.[_index]) {
                            const quantidadeAtual = carrinho?.itens[index].quantidade;
                            carrinho.itens[index].quantidade = _quantidade;
                            if (store.validaQuantidadeMaxima(carrinho?.itens[index])) {
                                store.addItem(carrinho?.itens[index])
                            } else {
                                carrinho.itens[index].quantidade = quantidadeAtual;
                            }
                            setUpdated(!updated);
                        }
                    }}
                    onRemove={(_index) => {
                        store.removeItem(_index)
                    }}
                />
            })}
        </>)
    }, [itensCarrinho, updated, store]);

    const renderAvulso = useMemo(() => {
        return (<>
            {itensCarrinho?.map((item: any, index: number) => {
                const originalIndex = item?._originalIndex ?? index;
                return <ItemAvulso
                        key={`item-${item?.id ?? index}`}
                        index={originalIndex}
                        item={item}
                        onChange={(_index, _quantidade) => {
                            const carrinho = { ...store.getCarrinho() };
                            if (carrinho?.avulsos?.[originalIndex]) {
                                const quantidadeAtual = carrinho.avulsos[originalIndex].quantidade;
                                carrinho.avulsos[originalIndex].quantidade = _quantidade;
                                if (store.validaQuantidadeMaximaAvulso(carrinho?.avulsos[originalIndex], isAdmin)) {
                                    store.addItemAvulso(carrinho?.avulsos[originalIndex], false, estadoId);
                                } else {
                                    carrinho.avulsos[originalIndex].quantidade = quantidadeAtual;
                                }
                                setUpdated(!updated);
                            }
                        }}
                        onRemove={() => {
                            store.removeItemAvulso(originalIndex);
                        }}
                    />
            })}
        </>)
    }, [itensCarrinho, store, updated, isAdmin]);

    const vendaAvulso = useMemo(() => {
        return tipoVenda === 'avulso';
    }, [tipoVenda]);

    const carrinhoVazio = useMemo(() => {
        return (!carrinho || !itensCarrinho?.length);
    }, [carrinho, itensCarrinho]);  
    
    const isAvulso = useMemo(() => {
        return (carrinho?.venda === 'avulso' && !carrinhoVazio) || (carrinhoVazio && tipoVenda === 'avulso');
    }, [carrinho, tipoVenda, carrinhoVazio]);

    const valorMinimo = useMemo(() => {
        const parametro = parametros?.data?.find((i:any) => i?.id === PROJETOS_AVULSO_VALOR_MINIMO_ID);
        return Number(parametro?.valor || 0)
    }, [parametros]);

    const progress = useMemo(() => {
        if (isAdmin) return 100;
        if (!valorMinimo) return 100;

        const percentual = (valorTotal() / valorMinimo) * 100;
        return Math.min(Math.max(percentual, 0), 100);
    }, [valorMinimo, isAdmin, valorTotal]);

    const hasError = useMemo(() => {
        if (!itensCarrinho || !itensCarrinho?.length) return false;
        return itensCarrinho?.some((i: TCarrinhoAvulso) => checkError(i?.componente?.categoria_componentes_id || 0, i?.quantidade))
    }, [itensCarrinho, checkError]);

    const indisponiveis = useMemo(() => {
        if (!vendaAvulso) return false;
        if (!carrinho?.avulsos?.length) return false;
        const itensIds = avulsos?.data?.map((i: any) => i?.id) || [];
        return carrinho?.avulsos?.some((i: any) => !itensIds?.includes(i?.componente?.id));
    }, [carrinho?.avulsos, vendaAvulso, avulsos]);

    const semItensValidos = useMemo(() => {
        return !itensCarrinho?.length || itensCarrinho.some((i: any) => i.quantidade < 1);
    }, [itensCarrinho]);

    const disabled = useMemo(() => {
        if (carrinho?.venda !== 'avulso') return semItensValidos;
        return hasError || indisponiveis || progress < 100 || semItensValidos;
    }, [carrinho?.venda, semItensValidos, indisponiveis, progress, hasError]);

    const textoFinalizar = useMemo(() => {
        if (indisponiveis) return "Para continuar, remova os itens indisponíveis do seu carrinho";
        if (disabled && semItensValidos)  return "Para prosseguir, selecione pelo menos um item.";

        return "";
    }, [itensCarrinho, indisponiveis, disabled, semItensValidos]);

    return <>
        <div className="Carrinho">
            <div className="header"
                onClick={() => store.toggleOpen()}
            >
                <ShoppingCart color={"secondary"} />
            </div>
            <div className="content">
                {itensCarrinho?.map((item: any, index: number) => {
                    return <ItemMini
                        key={`item-${index}`}
                        index={index}
                        item={item}
                    />
                })}
            </div>
        </div>
        <Drawer className="carrinho-drawer" id="carrinho-drawer" open={open} anchor={anchor} style={{ width: "286px", minHeight: "400px",  zIndex: theme.zIndex.drawer + 2}}>
            <Box paddingLeft={'10px'} paddingRight={'10px'} >
                <Button
                    variant="text" 
                    color={ "primary"}
                    startIcon={<Close />}
                    style={{ marginTop: 10, marginBottom: carrinho?.venda === 'avulso' ? 5 : 30 }}
                    onClick={() => { store.toggleOpen() }}
                >
                    Fechar
                </Button>
            </Box>
                
            <Box className="aviso-container">
                <Avatar className="avatar-error">
                    <ErrorOutlineOutlined/>
                </Avatar> 
                <span className="aviso-carrinho">
                    { isAvulso 
                        ? "Atualmente a opção de pedido avulso está disponível apenas para Pessoa Física."
                        : "Atualmente não é possível adicionar geradores diferentes no mesmo pedido"
                    }
                </span>
            </Box>

            <Box className="total-container">
                <Avatar className="total-icon">
                    <ShoppingCart color={"secondary"} />
                </Avatar> 
                <span className="total-title">Total: </span>
                <span className="total-value">{Formater.toString(valorTotal() || 0, TypeRecords.CURRENCY  )}</span>
            </Box>
            <Box className="box-itens">
                {!itensCarrinho?.length && (<>
                    <Box><Typography variant="body1">Seu carrinho está vazio.</Typography></Box>
                </>)}

                {carrinho?.venda === 'avulso' ? renderAvulso : renderKit }
            </Box>
            <Box className="acoes">
                {/* <Button 
                    className="acao" 
                    variant="outlined" 
                    color="secondary" 
                    onClick={() => { store.toggleOpen() }}
                >
                    Continuar comprando
                </Button> */}
                <Tooltip title={textoFinalizar}>
                    <Box style={ isAvulso ? { width : '100%' } : {} }>
                        { isAvulso && !isAdmin && (
                            <>
                                <Typography variant="body2">
                                    {progress >= 100
                                        ? "🎉 Parabéns, pedido mínimo atingido!"
                                        : (
                                            <>
                                                Faltam <strong>{Formater.toString((valorMinimo - valorTotal()).toFixed(2) || 0, TypeRecords.CURRENCY)}</strong> para atingir o pedido mínimo de{" "}
                                                <strong>{Formater.toString(valorMinimo.toFixed(2) || 0, TypeRecords.CURRENCY)}</strong>
                                            </>
                                        )}
                                </Typography>
                                <LinearProgress 
                                    variant="determinate" 
                                    value={progress}
                                    color={progress >= 100 ? "primary" : "warning"}
                                    sx={{
                                        height: '12px',
                                        borderRadius: '8px',
                                        margin: '5px 0px 20px 0px',
                                    }}
                                />
                            </>
                        )}

                        <Button
                            fullWidth
                            className="acao"
                            disabled={disabled} 
                            variant="contained" 
                            color="primary" 
                            endIcon={<ArrowForwardIcon />}
                            onClick={handleFinalizarCarrinho}
                        >
                            Finalizar
                        </Button>
                    </Box>
                </Tooltip>
            </Box>
        </Drawer>
    </>
};

export { Carrinho };